export default Object.freeze({
  FieldValue: 'field-value',
  FieldSearchValue: 'field-search-value',
});
